import axios from 'axios';
import { camelizeKeys } from 'humps';

export const asyncSend = async ({
  method, url, data, withCredentials = false, transformResponseFunc,
}) => {
  const response = await axios({
    method,
    url,
    data,
    withCredentials,
    transformResponse: transformResponseFunc
      ? [...axios.defaults.transformResponse, transformResponseFunc]
      : axios.defaults.transformResponse,
  });
  return response.data;
};

const asyncSendFactory = ({
  method, url, withCredentials, urlFactory, transformResponseFunc,
}) => {
  if (url) {
    return (args) => {
      const data = args ? args.data : undefined;
      return asyncSend({
        method, url, data, withCredentials, transformResponseFunc,
      });
    };
  }
  if (urlFactory) {
    return ({ data, ...createUrlArgs }) => {
      const createdUrl = urlFactory(createUrlArgs);
      return asyncSend({
        method, url: createdUrl, data, withCredentials, transformResponseFunc,
      });
    };
  }
  throw Error('url or urlFactory must be provided');
};

export const createAsyncGet = ({
  url,
  withCredentials,
  urlFactory,
  transformResponseFunc,
}) => asyncSendFactory({
  method: 'get', url, withCredentials, urlFactory, transformResponseFunc,
});

export const createAsyncPost = ({ url, urlFactory, withCredentials }) => asyncSendFactory({
  method: 'post',
  url,
  urlFactory,
  withCredentials,
});

export const withCamelization = asyncSender => async (...args) => {
  const data = await asyncSender(...args);
  return camelizeKeys(data);
};
